import React, { Children, FunctionComponent, ReactNode } from 'react';
import { Link } from 'gatsby';
import { ParentPage } from '../../types/common';
import InternalLink from '../InternalLink';
import './styles.scss';

type BreadcrumbProps = {
  data: ParentPage;
  theme?: {
    class: string;
  };
}

function limitCharacters(text: string | undefined, limit = 48): string {
  if (!text) return '';
  return text.slice(0, limit) + (text.length > limit ? '...' : '');
}

function getParentsLinks(data: ParentPage): ReactNode[] {
  if (data.parentPage) {
    return [
      ...getParentsLinks(data.parentPage),
      <InternalLink reference={data.parentPage} className='text-bold'>{limitCharacters(data.parentPage.title)}</InternalLink>,
    ]
  }
  return [<Link to='/' className='text-bold'>Home</Link>];
}

function insertBetween(element: ReactNode, array: ReactNode[]) {
  return array.flatMap((item) => [element, item]).slice(1);
};

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({ data, theme }) => {
  const links = [...getParentsLinks(data), <p className='text'>{limitCharacters(data.title)}</p>];
  const list = insertBetween(<span className='text'>|</span>, links);

  return (
    <div className={`breadcrumb ${theme?.class}`}>
      {Children.toArray(list.map(data => <>{data}</>))}
    </div>
  );
}

export default Breadcrumb;

